import type { IconSvgObject } from './types';

const CornerUpRightIcon: IconSvgObject = [
  ["path", { d: "M19 9H12C8.22876 9 6.34315 9 5.17157 10.1716C4 11.3431 4 13.2288 4 17V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 4C15 4 20 7.68245 20 9.00004C20 10.3176 15 14 15 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerUpRightIcon;
